import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { BrowserRouter as Router, } from "react-router-dom";
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
//import store from './store'
import { store } from './Store/store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
     <Router> 
    <App />
    </Router> 
        
    </Provider> 
      </React.StrictMode>
);
/*
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
